<template>
  <div class="content-dashboard">
    <h3>{{ $t("mollie_status.title") }}</h3>

    <div v-if="mollieStore.loading" class="spinner-container">
      <div class="spinner"></div>
      <p class="text-center mt-3">{{ $t("mollie_status.loading") }}</p>
    </div>

    <div v-else-if="mollieStore.isConnected" class="mollie-connected">
      <div class="success-status">
        <i class="ti ti-check text-success"></i>
        <h4>{{ $t("mollie_status.connected.title") }}</h4>
        <p>{{ $t("mollie_status.connected.message") }}</p>
      </div>

      <div class="mollie-details">
        <div class="detail-item" v-if="mollieStore.company">
          <strong>{{ $t("mollie_status.connected.company") }}:</strong>
          <span>{{ mollieStore.company }}</span>
        </div>
        <div class="detail-item" v-if="mollieStore.mollieId">
          <strong>{{ $t("mollie_status.connected.organization_id") }}:</strong>
          <span>{{ mollieStore.mollieId }}</span>
        </div>
        <div class="detail-item" v-if="mollieStore.statusMessage">
          <strong>{{ $t("mollie_status.connected.status") }}:</strong>
          <span>{{ mollieStore.statusMessage }}</span>
        </div>
        <div class="detail-item" v-if="mollieStore.connectionDate">
          <strong>{{ $t("mollie_status.connected.connected_since") }}:</strong>
          <span>{{ formatDate(mollieStore.connectionDate) }}</span>
        </div>
      </div>
    </div>

    <div v-else class="mollie-not-connected">
      <div class="warning-status">
        <i class="ti ti-alert-triangle text-warning"></i>
        <h4>{{ $t("mollie_status.not_connected.title") }}</h4>
        <p>{{ $t("mollie_status.not_connected.message") }}</p>
      </div>

      <div class="mollie-actions">
        <a v-if="mollieStore.oauthUrl" :href="mollieStore.oauthUrl" target="_self" class="btn btn-orange">
          <i class="ti ti-link"></i>
          {{ $t("mollie_status.not_connected.connect_button") }}
        </a>
        <p v-else class="text-muted">Aucun lien de connexion disponible pour le moment.</p>
        <a href="https://my.mollie.com" target="_blank" class="btn btn-orange ms-3">
          <i class="ti ti-external-link"></i>
          {{ $t("mollie_status.not_connected.access_button") }}
        </a>
      </div>
    </div>

    <div v-if="mollieStore.error" class="alert alert-danger mt-3">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ mollieStore.error }}</span>
        <button @click="retryFetch" class="btn btn-outline-orange btn-sm">
          {{ $t("mollie_status.retry") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { useMollieStore } from "@/stores/mollieStore";

  export default {
    name: "MollieStatusView",
    setup() {
      const mollieStore = useMollieStore();
      return { mollieStore };
    },
    mounted() {
      this.mollieStore.fetchSellerStatus();
    },
    methods: {
      retryFetch() {
        this.mollieStore.fetchSellerStatus();
      },
      formatDate(dateString) {
        if (!dateString) return "";
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString("fr-FR", {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
        } catch (error) {
          return dateString;
        }
      },
    },
  };
</script>

<style scoped>
  .mollie-connected,
  .mollie-not-connected {
    padding: 20px 0;
  }

  .success-status {
    text-align: center;
    padding: 30px 20px;
    background-color: var(--light);
    border-radius: 10px;
    margin-bottom: 20px;
  }

  .success-status i {
    font-size: 48px;
    color: var(--green);
    margin-bottom: 15px;
    display: block;
  }

  .success-status h4 {
    color: var(--blue);
    font-weight: 600;
    margin-bottom: 10px;
    font-size: 18px;
  }

  .success-status p {
    color: var(--dark);
    margin-bottom: 0;
    font-size: 15px;
  }

  .warning-status {
    text-align: center;
    padding: 30px 20px;
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 10px;
    margin-bottom: 20px;
  }

  .warning-status i {
    font-size: 48px;
    color: var(--orange);
    margin-bottom: 15px;
    display: block;
  }

  .warning-status h4 {
    color: var(--blue);
    font-weight: 600;
    margin-bottom: 10px;
    font-size: 18px;
  }

  .warning-status p {
    color: var(--dark);
    margin-bottom: 0;
    font-size: 15px;
  }

  .mollie-details {
    background-color: var(--white);
    border: 1px solid #aeb1ba;
    border-radius: 10px;
    padding: 20px;
  }

  .detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid var(--light);
    font-size: 15px;
  }

  .detail-item:last-child {
    border-bottom: none;
  }

  .detail-item strong {
    color: var(--blue);
    font-weight: 600;
  }

  .detail-item span {
    color: var(--dark);
  }

  .mollie-actions {
    text-align: center;
    padding: 20px;
  }

  .mollie-actions .btn {
    padding: 12px 30px;
    font-size: 16px;
    font-weight: 600;
  }

  .mollie-actions .btn i {
    margin-right: 8px;
  }

  .spinner-container {
    text-align: center;
    flex-direction: column;
    padding: 40px 20px;
  }

  .text-success {
    color: var(--green) !important;
  }

  .text-warning {
    color: var(--orange) !important;
  }
  .btn-orange:active{
   color: white !important;
  }

  /* Mobile Responsive Optimizations (< 768px) */
  @media (max-width: 767px) {
    /* Main title */
    .content-dashboard h3 {
      font-size: 20px;
      margin-bottom: 20px;
      text-align: center;
    }

    /* Connected/Not Connected containers */
    .mollie-connected,
    .mollie-not-connected {
      padding: 15px 0;
    }

    /* Success status card */
    .success-status {
      padding: 25px 15px;
      margin-bottom: 15px;
      border-radius: 8px;
    }

    .success-status i {
      font-size: 40px;
      margin-bottom: 12px;
    }

    .success-status h4 {
      font-size: 16px;
      margin-bottom: 8px;
      line-height: 1.4;
    }

    .success-status p {
      font-size: 14px;
      line-height: 1.5;
      padding: 0 10px;
    }

    /* Warning status card */
    .warning-status {
      padding: 25px 15px;
      margin-bottom: 15px;
      border-radius: 8px;
    }

    .warning-status i {
      font-size: 40px;
      margin-bottom: 12px;
    }

    .warning-status h4 {
      font-size: 16px;
      margin-bottom: 8px;
      line-height: 1.4;
    }

    .warning-status p {
      font-size: 14px;
      line-height: 1.5;
      padding: 0 10px;
    }

    /* Mollie details card */
    .mollie-details {
      padding: 15px;
      border-radius: 8px;
    }

    /* Detail items - stack on mobile for better readability */
    .detail-item {
      flex-direction: column;
      align-items: flex-start;
      padding: 15px 0;
      font-size: 14px;
      gap: 8px;
    }

    .detail-item strong {
      font-size: 14px;
      margin-bottom: 4px;
    }

    .detail-item span {
      font-size: 14px;
      word-break: break-word;
      width: 100%;
    }

    /* Actions section */
    .mollie-actions {
      padding: 15px 10px;
    }

    /* Buttons - stack vertically on mobile */
    .mollie-actions .btn {
      display: block;
      width: 100%;
      padding: 14px 20px;
      font-size: 15px;
      margin: 0 0 12px 0 !important;
      text-align: center;
    }

    .mollie-actions .btn:last-child {
      margin-bottom: 0 !important;
    }

    .mollie-actions .btn i {
      margin-right: 6px;
      font-size: 16px;
    }

    .mollie-actions p {
      font-size: 14px;
      padding: 0 10px;
      margin-bottom: 15px;
    }

    /* Alert error message */
    .alert {
      margin-top: 15px !important;
      padding: 12px 15px;
      font-size: 14px;
      border-radius: 8px;
    }

    .alert .d-flex {
      flex-direction: column;
      gap: 12px;
      align-items: stretch !important;
    }

    .alert .btn-sm {
      width: 100%;
      padding: 10px 15px;
      font-size: 14px;
    }

    /* Spinner container */
    .spinner-container {
      padding: 30px 15px;
    }

    .spinner-container p {
      font-size: 14px;
      margin-top: 15px !important;
    }
  }

  /* Small mobile devices (< 480px) */
  @media (max-width: 479px) {
    .content-dashboard h3 {
      font-size: 18px;
      margin-bottom: 15px;
    }

    .success-status,
    .warning-status {
      padding: 20px 12px;
    }

    .success-status i,
    .warning-status i {
      font-size: 36px;
    }

    .success-status h4,
    .warning-status h4 {
      font-size: 15px;
    }

    .success-status p,
    .warning-status p {
      font-size: 13px;
    }

    .mollie-details {
      padding: 12px;
    }

    .detail-item {
      padding: 12px 0;
      font-size: 13px;
    }

    .mollie-actions .btn {
      padding: 12px 16px;
      font-size: 14px;
    }
  }
</style>
